import { DialogType, DialogWidget } from '@tableau/widgets';
import * as React from 'react';
import { connect } from 'react-redux';
import { MapDispatchToProps } from '../../app/utils/ConnectUtils';
import { Messages } from '../../codegen/Localize';
import { CreateCustomDialogFn, ReactModalService } from '../../commonInfra/dialogs/ReactModalService';
import { requestUploadWorkbookAction } from '../actions/UploadWorkbookActions';
import { UploadWorkbookStyles } from '../styles/UploadWorkbookStyles';
import { UploadWorkbookDialog, UploadWorkbookDialogValues, UploadWorkbookDispatchProps } from './UploadWorkbookDialog';

export const mapDispatchToProps: MapDispatchToProps<UploadWorkbookDispatchProps> = (dispatch) => ({
  uploadWorkbookActionDispatch: (values: UploadWorkbookDialogValues, overwrite: boolean = false) => {
    dispatch(requestUploadWorkbookAction({
      data: values,
      overwrite
    }));
  }
});

const ConnectedUploadWorkbookDialog = connect(null, mapDispatchToProps)(UploadWorkbookDialog);

/**
 * Options used for ReactModalService
 */
export function UploadWorkbookDialogOpts(
  snapshot?: UploadWorkbookDialogValues, parentElement?: React.RefObject<any>
): CreateCustomDialogFn {
  return (closeAndDismiss) => {
    const dialogProps = ReactModalService.getDefaultDialogProps({
      type: DialogType.NormalWithTitleBar,
      title: Messages.contentUpload_uploadWorkbook(),
      showCloseButton: false,
      dialogWidth: UploadWorkbookStyles.dialogWidth,
      shouldNotCloseOnGlassClick: true,
      testId: 'upload-workbook'
    }, closeAndDismiss);

    return (
      <DialogWidget {...dialogProps}>
        <ConnectedUploadWorkbookDialog
          close={closeAndDismiss.close}
          snapshot={snapshot}
          parentElement={parentElement}
        />
      </DialogWidget>
    );
  };
}
